import { createRoutine } from 'redux-saga-routines'
import { ITimeTrackingState } from './timetracking.interface'
import { mergeArrayAndOverrideDuplicates } from '../utils/index.common'
const initialTimeTrackingState: ITimeTrackingState = {
  timeTrackingList: [],
  selectedTimeTracking: {
    billingCategoryId: 0,
    seconds: 0,
    notes: '',
    recordedDate: new Date(2019, 10, 9, 11, 8, 0),
    id: 0
  },
  ListLoading: false,
  error: false,
  loading: false,
  meta: {
    perPage: 0,
    totalPages: 0,
    totalResults: 0,
    curPage: 0
  }
}

export const getTimeTrackingList = createRoutine('GET_TIMETRACKING_LIST')
export const showTimeTracking = createRoutine('SHOW_TIMETRACKING')
export const editTimeTracking = createRoutine('EDIT_TIMETRACKING')
export const addTimeLog = createRoutine('ADD_TIME_LOG')
export const addTimeLogBackground = createRoutine('ADD_TIME_LOG_BG')
export const deleteTimeLog = createRoutine('DELETE_TIME_LOG')
// Pending
// Edit TrackingItem
export default function device(state = initialTimeTrackingState, action: any) {
  switch (action.type) {
    case getTimeTrackingList.TRIGGER:
      return { ...state,  ListLoading: true, timeTrackingList: [], error: false, success: false }
    case getTimeTrackingList.SUCCESS:
      return {
        ...state,
        ListLoading: false,
        success: true,
        timeTrackingList: action.payload.billings,
        meta: action.payload.meta,
        error: false
      }
    case getTimeTrackingList.FAILURE:
      return {
        ...state,
        ListLoading: false,
        success: false,
        error: true
      }
    case showTimeTracking.TRIGGER:
      return {
        ...state,
        loading: true,
        selectedTimeTracking: {},
        error: false,
        success: false
      }
    case showTimeTracking.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        selectedTimeTracking: action.payload,
        error: false
      }
    case showTimeTracking.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }
    case editTimeTracking.TRIGGER:
      return {
        ...state,
        loading: true,
        error: false,
        success: false
      }
    case editTimeTracking.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        selectedTimeTracking: action.payload,
        error: false,
        timeTrackingList: mergeArrayAndOverrideDuplicates(state.timeTrackingList, action.payload)
      }
    case editTimeTracking.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }
    case addTimeLog.TRIGGER:
      return {
        ...state, loading: true, error: false, success: false
      }
    case addTimeLog.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        selectedTimeTracking: action.payload,
        error: false,
        timeTrackingList: mergeArrayAndOverrideDuplicates([action.payload], state.timeTrackingList)
      }
    case addTimeLog.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }

    case deleteTimeLog.TRIGGER:
      return {
        ...state, loading: true, error: false, success: false
      }
    case deleteTimeLog.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        timeTrackingList: mergeArrayAndOverrideDuplicates(state.timeTrackingList, +action.payload.id)
      }
    case deleteTimeLog.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }
      case addTimeLogBackground.TRIGGER:
        return {
          ...state, loading: true, error: false, success: false
        }
      case addTimeLogBackground.SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          selectedTimeTracking: action.payload,
          error: false
        }
      case addTimeLogBackground.FAILURE:
        return {
          ...state,
          loading: false,
          success: false,
          timeTrackingList: state.timeTrackingList.concat(action.payload),
          error: true
        }
    default:
      return state
  }
}
